import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useConsent, setConsent } from "@/lib/consent";
import { useTutorial } from "@/lib/tutorial";

export default function CookieBanner() {
  const consent = useConsent();
  const { running } = useTutorial();
  if (consent || running) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-[420px] z-[90] surface p-4 shadow-2xl backdrop-blur-xl" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <Cookie size={18} className="text-[#B8A4FF] mt-0.5 shrink-0" />
        <p className="text-[12.5px] leading-[1.6] text-[#B0AEBC]">
          We use essential storage to keep you signed in. With your permission, we also load
          Google Analytics, the Meta Pixel and Google AdSense, which set analytics and advertising cookies.{" "}
          <Link to="/cookie-policy" className="text-[#B8A4FF] hover:underline" data-testid="cookie-banner-policy-link">Cookie policy</Link>
        </p>
      </div>
      <div className="flex justify-end gap-2 mt-3">
        <button className="btn-ghost text-[12.5px] px-3 py-1.5 rounded-full" onClick={() => setConsent("rejected")} data-testid="cookie-reject-btn">
          Reject non-essential
        </button>
        <button className="btn-primary text-[12.5px] px-4 py-1.5 rounded-full" onClick={() => setConsent("accepted")} data-testid="cookie-accept-btn">
          Accept all
        </button>
      </div>
    </div>
  );
}
